/**
 * vc-tool-tracking.js - Herbruikbare toolmeting voor Vijvercentrum-tools
 * (GOAT-TOOLS S2-C, Amplitude-programmahub 39fb0ce6 sectie 6.3)
 *
 * Eventset (BESTAAND, geen nieuwe events):
 *   vc:tool_started, vc:tool_step_completed, vc:tool_inputs_submitted,
 *   vc:advice_generated, vc:recommendation_clicked, vc:tool_completed,
 *   vc:tool_error
 *
 * Sinks per event (patroon = assets/vijvercheck-v2.js + amplitude-analytics.liquid):
 *   1. gtag + dataLayer (GA4; snake_case, gtag is globaal via de Shopify GA4-app)
 *   2. Batch-POST naar https://data.vijvercentrum.nl/tool/collect (SST-worker),
 *      die server-side doorzet naar de eigen events-tabel (Supabase edge
 *      function /events, zelfde collector als VijverCheck) EN Amplitude EU
 *      HTTP v2 met insert_id-dedupe (zelfde patroon als de GA4-fanout).
 *
 * Privacy / AVG:
 *   - Verstuurt UITSLUITEND na analytics-consent (Shopify Customer Privacy
 *     API, respecteert GPC), identiek aan VijverCheck.
 *   - Property-allow-list; e-mail/telefoon-waarden worden gedropt.
 *   - Identiteit: device_id = 'ga_' + GA client_id (zelfde conventie als de
 *     worker-fanout en de Amplitude-snippet). Nooit e-mail/naam/adres.
 *   - tool_session_id: hergebruikt sessionStorage-sleutel 'vc_tool_session'
 *     (zelfde record als amplitude-analytics.liquid, attributieketen intact).
 *
 * Gebruik (in een sectie of tool-script):
 *   vcToolTracking.init({ tool_name: 'uvc-keuzehulp', tool_version: 'v9' });
 *   vcToolTracking.started(); .stepCompleted('lamp_type', {step_value:'t5'});
 *   .inputsSubmitted({inputs_count:2}); .adviceGenerated({result_count:4,
 *     engine_version:..., rule_version:...}); .recommendationClicked({...});
 *   .completed(); .error('client_exception');
 *   Auto-instrumentatie UV-C keuzehulp: init({ auto: 'uvc-keuzehulp', ... })
 *
 * Brandregel: geen em/en-dash, alleen ASCII.
 */
(function (root, factory) {
  var api = factory(root || {});
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.vcToolTracking = api;
})(typeof window !== 'undefined' ? window : null, function (win) {
  'use strict';

  var COLLECT_URL = 'https://data.vijvercentrum.nl/tool/collect';
  var SCHEMA_VERSION = 1;
  var TOOL_KEY = 'vc_tool_session';
  var SEQ_KEY = 'vc_tool_seq';
  var FLUSH_MS = 1500;

  var EVENTS = {
    started:               'vc:tool_started',
    step_completed:        'vc:tool_step_completed',
    inputs_submitted:      'vc:tool_inputs_submitted',
    advice_generated:      'vc:advice_generated',
    recommendation_clicked:'vc:recommendation_clicked',
    completed:             'vc:tool_completed',
    error:                 'vc:tool_error'
  };
  /* GA4 event-namen: snake_case (GA4 staat geen ':' toe). */
  var GA4_NAMES = {
    'vc:tool_started':          'tool_started',
    'vc:tool_step_completed':   'tool_step_completed',
    'vc:tool_inputs_submitted': 'tool_inputs_submitted',
    'vc:advice_generated':      'advice_generated',
    'vc:recommendation_clicked':'recommendation_clicked_tool',
    'vc:tool_completed':        'tool_completed',
    'vc:tool_error':            'tool_error'
  };

  /* Allow-list = Amplitude-hub sectie 7 (tool-set + relevante globale keys). */
  var PROP_KEYS = ['tool_name','tool_version','tool_session_id','step_id',
    'step_index','step_value','pond_type','pond_volume_band','problem_type',
    'urgency','rule_id','rule_version','engine_version','recommendation_id',
    'recommendation_rank','recommendation_type','product_id','result_count',
    'inputs_count','error_code','schema_version','environment','page_type',
    'canonical_path','language','device_type'];
  var PROP_SET = {};
  PROP_KEYS.forEach(function (k) { PROP_SET[k] = 1; });

  var EMAIL_RE = /[\w.+-]+@[\w.-]+\.[a-z]{2,}/i;
  var PHONE_RE = /\+?\d[\d\s().-]{6,}\d/;

  var cfg = { tool_name: '', tool_version: '', environment: 'production' };
  var queue = [];
  var flushTimer = null;
  var seq = 0;
  var startedSent = false;
  var completedSent = false;

  /* ---------- consent (identiek aan vijvercheck-v2.js) ---------- */
  function hasConsent() {
    try { if (win.navigator && win.navigator.globalPrivacyControl === true) return false; } catch (_) {}
    try {
      var cp = win.Shopify && win.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
        return !!cp.analyticsProcessingAllowed();
      }
    } catch (_) {}
    try { if (typeof cfg.consentOverride === 'function') return !!cfg.consentOverride(); } catch (_) {}
    return !!cfg.defaultConsent;
  }

  /* ---------- identiteit ---------- */
  function gaClientId() {
    try {
      var m = String((win.document && win.document.cookie) || '').match(/(?:^|;\s*)_ga=([^;]+)/);
      if (!m) return null;
      var parts = m[1].split('.');
      if (parts.length >= 4) return parts[parts.length - 2] + '.' + parts[parts.length - 1];
    } catch (_) {}
    return null;
  }
  function deviceId() {
    var cid = gaClientId();
    return cid ? 'ga_' + cid : 'vctool_' + toolSessionId();
  }

  /* Zelfde record als amplitude-analytics.liquid getToolContext(). */
  function toolSessionId() {
    var rec = null;
    try { rec = JSON.parse(win.sessionStorage.getItem(TOOL_KEY) || 'null'); } catch (_) {}
    if (!rec || !rec.id || (cfg.tool_name && rec.tool !== cfg.tool_name)) {
      rec = { tool: cfg.tool_name || (rec && rec.tool) || 'tool', id: genId(), ts: Date.now() };
      try { win.sessionStorage.setItem(TOOL_KEY, JSON.stringify(rec)); } catch (_) {}
    }
    return rec.id;
  }
  function genId() {
    try { if (win.crypto && win.crypto.randomUUID) return 'vc_' + win.crypto.randomUUID(); } catch (_) {}
    return 'vc_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  }
  function nextSeq() {
    try {
      var v = parseInt(win.sessionStorage.getItem(SEQ_KEY) || '0', 10) || 0;
      v += 1;
      win.sessionStorage.setItem(SEQ_KEY, String(v));
      return v;
    } catch (_) { return ++seq; }
  }

  /* ---------- scrub (allow-list + waarde-scrub) ---------- */
  function scrub(props) {
    var out = {};
    if (!props || typeof props !== 'object') return out;
    Object.keys(props).forEach(function (k) {
      if (!PROP_SET[k]) return;
      var v = props[k];
      if (v === null || v === undefined) return;
      if (typeof v === 'object') return;
      if (typeof v === 'string') {
        if (EMAIL_RE.test(v) || PHONE_RE.test(v)) return;
        v = v.slice(0, 200);
      }
      out[k] = v;
    });
    return out;
  }

  /* ---------- verzenden ---------- */
  function baseProps(extra) {
    var p = scrub(extra);
    if (p.tool_name == null && cfg.tool_name) p.tool_name = cfg.tool_name;
    if (p.tool_version == null && cfg.tool_version) p.tool_version = cfg.tool_version;
    if (p.engine_version == null && cfg.engine_version) p.engine_version = cfg.engine_version;
    if (p.rule_version == null && cfg.rule_version) p.rule_version = cfg.rule_version;
    p.tool_session_id = toolSessionId();
    p.schema_version = SCHEMA_VERSION;
    if (cfg.environment) p.environment = cfg.environment;
    try { p.canonical_path = (win.location && win.location.pathname || '').slice(0, 120); } catch (_) {}
    return p;
  }

  function track(eventKey, props) {
    var name = EVENTS[eventKey];
    if (!name) return null;
    var p = baseProps(props);
    /* Sink 1: GA4 via globale gtag + dataLayer (bestaand patroon). */
    try { if (typeof win.gtag === 'function') win.gtag('event', GA4_NAMES[name], p); } catch (_) {}
    try {
      win.dataLayer = win.dataLayer || [];
      win.dataLayer.push(Object.assign({ event: GA4_NAMES[name], ts: Date.now() }, p));
    } catch (_) {}
    /* Sink 2: worker-collector (eigen tabel + Amplitude), alleen met consent. */
    if (hasConsent()) {
      queue.push({ name: name, seq: nextSeq(), ts: new Date().toISOString(), properties: p });
      scheduleFlush();
    }
    return p;
  }

  function scheduleFlush() {
    if (flushTimer) return;
    flushTimer = setTimeout(flush, FLUSH_MS);
  }

  function payload(batch) {
    return {
      v: 1,
      source: 'vc-tool-tracking',
      tool_session_id: toolSessionId(),
      device_id: deviceId(),
      events: batch
    };
  }

  function flush() {
    flushTimer = null;
    if (!queue.length) return;
    var batch = queue.splice(0, queue.length);
    try {
      var fetchFn = cfg.fetchFn || (typeof win.fetch === 'function' ? win.fetch.bind(win) : null);
      if (!fetchFn) return;
      fetchFn(COLLECT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload(batch)),
        keepalive: true,
        credentials: 'omit',
        mode: 'cors'
      }).catch(function () {});
    } catch (_) {}
  }

  function flushBeacon() {
    if (!queue.length) return;
    if (!hasConsent()) { queue.length = 0; return; }
    try {
      var body = JSON.stringify(payload(queue.splice(0, queue.length)));
      if (win.navigator && typeof win.navigator.sendBeacon === 'function') {
        win.navigator.sendBeacon(COLLECT_URL, new (win.Blob || Blob)([body], { type: 'application/json' }));
      }
    } catch (_) {}
  }

  /* ---------- publieke API ---------- */
  var api = {
    init: function (options) {
      cfg = Object.assign({ environment: 'production' }, cfg, options || {});
      startedSent = false;
      completedSent = false;
      try {
        win.addEventListener && win.addEventListener('pagehide', flushBeacon);
      } catch (_) {}
      if (cfg.auto === 'uvc-keuzehulp') bindUvcKeuzehulp();
      return api;
    },
    started: function (props) {
      if (startedSent) return null;
      startedSent = true;
      return track('started', props);
    },
    stepCompleted: function (stepId, props) {
      var p = Object.assign({}, props || {}, { step_id: stepId });
      return track('step_completed', p);
    },
    inputsSubmitted: function (props) { return track('inputs_submitted', props); },
    adviceGenerated: function (props) { return track('advice_generated', props); },
    recommendationClicked: function (props) { return track('recommendation_clicked', props); },
    completed: function (props) {
      if (completedSent) return null;
      completedSent = true;
      return track('completed', props);
    },
    error: function (errorCode, props) {
      var p = Object.assign({}, props || {}, { error_code: errorCode || 'unknown' });
      return track('error', p);
    },
    flush: flush,
    _internals: { scrub: scrub, payload: payload, queue: queue, hasConsent: hasConsent,
      handleUvcClick: null, config: function () { return cfg; } }
  };

  /* ---------- auto-instrumentatie UV-C keuzehulp ----------
     Bindt op de bestaande stabiele DOM-hooks van
     sections/page-uv-c-lamp-kiezen.liquid; wijzigt NIETS aan de sectie:
     [data-lamp-type], .uvc-filter-chip (data-filter-dim/-val),
     .uvc-lamp-card, .uvc-filter-reset, [data-show-for-type]. */
  function visibleResultCount(doc) {
    try {
      var sections = doc.querySelectorAll('[data-show-for-type]');
      for (var i = 0; i < sections.length; i++) {
        var s = sections[i];
        if (s.classList && s.classList.contains('hidden')) continue;
        var cards = s.querySelectorAll('.uvc-lamp-card');
        var n = 0;
        for (var j = 0; j < cards.length; j++) {
          if (!cards[j].style || cards[j].style.display !== 'none') n++;
        }
        return n;
      }
    } catch (_) {}
    return null;
  }
  function handleFromHref(href) {
    try {
      var m = String(href || '').match(/\/products\/([a-z0-9-]+)/i);
      return m ? m[1] : null;
    } catch (_) { return null; }
  }

  function handleUvcClick(target, doc) {
    try {
      var el;
      el = target.closest && target.closest('[data-lamp-type]');
      if (el) {
        api.started({ step_index: 0 });
        api.stepCompleted('lamp_type', { step_value: el.dataset && el.dataset.lampType, step_index: 1 });
        return 'lamp_type';
      }
      el = target.closest && target.closest('.uvc-filter-chip');
      if (el) {
        api.started({ step_index: 0 });
        var dim = (el.dataset && (el.dataset.filterDim || 'wattage')) || 'wattage';
        var val = el.dataset && (el.dataset.filterVal != null ? el.dataset.filterVal : el.dataset.wattageFilter);
        api.stepCompleted('filter_' + dim, { step_value: val, step_index: 2 });
        api.inputsSubmitted({ inputs_count: 1, step_id: 'filter_' + dim });
        var n = visibleResultCount(doc);
        if (n !== null) api.adviceGenerated({ result_count: n, rule_id: 'uvc_dom_filter' });
        return 'filter';
      }
      el = target.closest && target.closest('.uvc-filter-reset');
      if (el) { api.stepCompleted('filter_reset', { step_index: 2 }); return 'reset'; }
      el = target.closest && target.closest('.uvc-lamp-card');
      if (el) {
        var link = target.closest && target.closest('a');
        var handle = link ? handleFromHref(link.getAttribute && link.getAttribute('href')) : null;
        api.recommendationClicked({ product_id: handle, recommendation_type: 'product' });
        api.completed({});
        return 'card';
      }
    } catch (e) {
      try { api.error('client_exception'); } catch (_) {}
    }
    return null;
  }
  api._internals.handleUvcClick = handleUvcClick;

  function bindUvcKeuzehulp() {
    var doc = win.document;
    if (!doc || !doc.addEventListener) return;
    /* Na de sectie-handlers (bubbling op document): filters zijn dan al toegepast. */
    doc.addEventListener('click', function (e) {
      if (!e || !e.target) return;
      setTimeout(function () { handleUvcClick(e.target, doc); }, 0);
    });
  }

  return api;
});
